import { LoginInProgressAuthError } from '@ms/yammer-web-authenticators';

export type IsPermanentFailure = (error: Error) => boolean;
export const isPermanentFailure: IsPermanentFailure = (error) => !(error instanceof LoginInProgressAuthError);
